import { StyleSheet, View } from "react-native";
import { ListingItem, type ListingItemProps } from "~/components/layout/ListingItem";
import { QendoIcon } from "~/components/QendoIcon";
import { Radius, Space } from "~/constants/sizing";
import { useTheme } from "~/providers/ThemeProvider";

export type EditListingItemProps = Omit<ListingItemProps, "hideChevron" | "badge" | "badgeVariant">;

export const EditListingItem = ({ children, ...listItemProps }: EditListingItemProps) => {
    const { colours, background } = useTheme();
    return (
        <ListingItem {...listItemProps} hideChevron>
            <View style={[styles.container, background.brand]}>
                <View>{children}</View>
                <QendoIcon name="edit" size={20} color={colours.icon.selected} />
            </View>
        </ListingItem>
    );
};

const styles = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "space-between",
        borderRadius: Radius.md,
        paddingHorizontal: Space.sm,
        paddingVertical: Space.xs,
        gap: Space.sm,
    },
});
